import { Question } from '../../../types/domainModels';
import { isDemographicQuestion } from '../../../util/questions';
import FormCheckbox from '../../common/forms/FormCheckbox';

interface SendToSurveyEndProps {
  question: Question | undefined;
}

const SendToSurveyEnd = ({
  question,
}: SendToSurveyEndProps): JSX.Element | null => {
  // Only show for demographic questions
  if (!question || !isDemographicQuestion(question)) {
    return null;
  }

  return (
    <FormCheckbox
      checkboxLabel="Send to Survey End"
      name="features.sendToSurveyEnd"
      tooltip="When enabled, this question will be moved to the end of the survey"
    />
  );
};

export default SendToSurveyEnd;
